export default "__VITE_ASSET__zSS3CZ$N__"